import { Typography } from '@mui/material'

export type ScheduleSetTimeCaptionProps = {
  caption?: string | null
}

export function ScheduleSetTimeCaption({
  caption,
}: ScheduleSetTimeCaptionProps) {
  if (!caption) return null

  return (
    <Typography
      sx={{
        mt: 0.5,
        display: 'block',
        fontSize: '12px',
        fontWeight: 600,
      }}
    >
      {caption}
    </Typography>
  )
}
